import React from 'react';
import SelectionCheckbox from '../../components/selection-checkbox';
import DropdownMenu from '../../components/dropdown-menu';
import groupCaretIcon from '../../assets/icons/group-caret.svg';
import {
  getGaugeColor,
  getLoadLabel,
  getLoadRate,
} from './truck-assignments.utils';

/**
 * En-tête de groupe : camion (couleur, identifiant, résumé, jauge de charge)
 * ou groupe « À placer ». Sert aussi de cible de glisser-déposer.
 * Avec onToggleCollapse, un clic sur l'en-tête (hors boutons, case et menu)
 * replie ou déplie ses lignes.
 */
export default function TruckGroupHeader({
  title,
  color,
  summary,
  isUnassigned = false,
  isUnavailable = false,
  load,
  badge,
  dispatchBadge,
  selectionState,
  onToggleSelect,
  action,
  menuItems,
  menuFooter,
  dropState,
  collapsed = false,
  onToggleCollapse,
  onDragOver,
  onDragLeave,
  onDrop,
}) {
  const rate = load ? getLoadRate(load.weight, load.capacity) : 0;
  const gaugeColor = getGaugeColor(rate);
  const loadLabel = getLoadLabel(rate);

  return (
    <div
      className={`ta-group ${isUnassigned ? 'ta-group--unassigned' : ''} ${
        isUnavailable ? 'ta-group--unavailable' : ''
      } ${dropState ? `ta-group--drop-${dropState}` : ''} ${
        onToggleCollapse ? 'ta-group--collapsible' : ''
      }`}
      onClick={
        onToggleCollapse
          ? (event) => {
              if (
                event.target.closest(
                  'button, input, label, .agv-dropdown, .agv-menu'
                )
              ) {
                return;
              }
              onToggleCollapse();
            }
          : undefined
      }
      aria-expanded={onToggleCollapse ? !collapsed : undefined}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <SelectionCheckbox
        checked={selectionState === 'all'}
        indeterminate={selectionState === 'some'}
        onChange={onToggleSelect}
        // Camion envoyé en exploitation : ses commandes ne se sélectionnent pas
        disabled={Boolean(dispatchBadge)}
        title={
          dispatchBadge
            ? 'Camion envoyé en exploitation : commandes verrouillées'
            : 'Sélectionner tout le groupe'
        }
      />
      {onToggleCollapse && (
        <img
          src={groupCaretIcon}
          alt=""
          width="7.79423"
          height="4.5"
          className={`agv-dg-group-header__caret ${
            collapsed ? 'agv-dg-group-header__caret--collapsed' : ''
          }`}
        />
      )}
      <span className="ta-group__color" style={{ backgroundColor: color }} />
      <span className="ta-group__title">{title}</span>
      <span className="ta-group__summary">{summary}</span>
      {load && load.capacity > 0 && (
        <>
          <span className="ta-gauge">
            <span
              className="ta-gauge__fill"
              style={{
                width: `${Math.min(rate, 100)}%`,
                backgroundColor: gaugeColor,
              }}
            />
          </span>
          <span
            className="ta-group__pct"
            style={loadLabel ? { color: gaugeColor } : undefined}
          >
            {Math.round(rate)} %{loadLabel && ` · ${loadLabel}`}
          </span>
        </>
      )}
      {badge && (
        <span
          className={`ta-badge ${badge.muted ? 'ta-badge--muted' : ''}`}
          title={badge.title}
        >
          {badge.label}
        </span>
      )}
      {dispatchBadge && (
        <span
          className="ta-badge ta-badge--dispatched"
          title={dispatchBadge.title}
        >
          {dispatchBadge.label}
        </span>
      )}
      <span className="ta-spacer" />
      {action && (
        <button
          type="button"
          className="ta-link"
          onClick={action.onClick}
          disabled={action.disabled}
          title={action.title}
        >
          {action.label}
        </button>
      )}
      <DropdownMenu
        items={menuItems}
        width={340}
        footer={menuFooter}
        renderTrigger={({ toggle }) => (
          <button
            type="button"
            className="ta-icon-btn"
            onClick={toggle}
            title="Actions du groupe"
          >
            ···
          </button>
        )}
      />
    </div>
  );
}
